module.exports = __webpack_public_path__ + "img/canada-cancer-male.3527487b.png";